<template>
  <div class="my-header">
    <img
      :src="util.getImageUrl(user.avatarUrl, '100x100')"
      alt
    >
    <el-dropdown
      class="dropdown"
      @command="onCommand"
    >
      <span class="el-dropdown-link">
        {{ (user.nickName || user.name || "").substring(0, 6) }}
        <!-- <i
          class="el-icon-arrow-down el-icon--right"
        ></i>-->
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="/my">
          进入我的
        </el-dropdown-item>
        <el-dropdown-item
          command="/my?modifyNickNameDialogVisible=true"
          divided
        >
          修改昵称
        </el-dropdown-item>
        <el-dropdown-item command="/my?modifyAvatarUrlDialogVisible=true">
          修改头像
        </el-dropdown-item>
        <el-dropdown-item command="/my?modifyPasswordDialogVisible=true">
          修改密码
        </el-dropdown-item>
        <el-dropdown-item
          command="/login"
          divided
        >
          退出
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'MyHeader',
  computed: {
    user() {
      return this.$store.state.sys.sysUser.me
    }
  },
  created() {
    this.$store.dispatch('me', {
      packageName: 'sys',
      className: 'sysUser',
      methodName: 'me',
      params: {}
    })
  },
  methods: {
    onCommand(e) {
      this.$router.push(e)
    }
  }
}
</script>

<style lang="less" scoped>
.my-header {
  height: 70px;
  line-height: 70px;
  img {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    margin: 18px auto;
  }
  .dropdown {
    vertical-align: top;
  }
}
</style>
